<script setup lang="ts">
import { useToast, type ToastKind } from '@/composables/useToast'

const { toasts, dismiss } = useToast()

const kindClasses: Record<ToastKind, string> = {
  success: 'border-l-status-green',
  error: 'border-l-status-red',
  info: 'border-l-accent',
}
</script>

<template>
  <div class="fixed bottom-4 right-4 z-[100] flex flex-col gap-2 w-[340px] max-w-[calc(100vw-2rem)]">
    <TransitionGroup
      enter-active-class="transition duration-medium ease-out"
      enter-from-class="opacity-0 translate-y-2"
      enter-to-class="opacity-100 translate-y-0"
      leave-active-class="transition duration-short ease-in"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-for="t in toasts"
        :key="t.id"
        class="bg-surface-card border border-subtle border-l-2 rounded shadow-lg px-3 py-2.5 flex items-start gap-2"
        :class="kindClasses[t.kind]"
      >
        <p class="flex-1 text-body-sm text-ink">{{ t.message }}</p>
        <button
          class="text-ink-muted hover:text-ink text-body-sm leading-none mt-0.5"
          aria-label="Dismiss"
          @click="dismiss(t.id)"
        >
          &times;
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>
